/** Remembers the last venue in view (sessionStorage — per-tab, so two tabs keep distinct venues). */
const LAST_VENUE_KEY = "staff.lastVenueId";

export function rememberLastVenue(venueId: string): void {
  try {
    sessionStorage.setItem(LAST_VENUE_KEY, venueId);
  } catch {
    /* storage unavailable (private mode) — the picker is the fallback */
  }
}

export function recallLastVenue(): string | null {
  try {
    return sessionStorage.getItem(LAST_VENUE_KEY);
  } catch {
    return null;
  }
}
